<template>
  <li @click="onItemSelected"
      v-bind:class="{ selected: selected === item.id }">

    <div class="ingredient-item fermentable" v-if="type === 'fermentable'">
      <div class="column name">
        <span>{{item.name}}</span>
        <span v-if="item.producer || item.country" class="sub-column">
                {{item.producer}} <i v-if="item.producer && item.country"> | </i>  {{item.country}}
                </span>
      </div>
      <div class="column type" :title="item.type">{{item.type}}</div>
      <div class="column color">{{item.color}}</div>
    </div>


    <div class="ingredient-item hop" v-if="type === 'hop'">
      <div class="column name">
        <span>{{item.name}}</span>
        <span v-if="item.origin" class="sub-column">
                {{item.origin}}
              </span>
      </div>
      <div class="column alpha">{{item.alphaAcid}}%</div>
      <div class="column type">{{item.type}}</div>
    </div>


    <div class="ingredient-item yeast" v-if="type === 'yeast'">
      <div class="column name">
        <span>{{item.name}}</span>
        <span v-if="item.laboratory" class="sub-column">
                {{item.laboratory}}
              </span>
      </div>
      <div class="column type" :title="item.type">{{item.type}}</div>
      <div class="column code">{{item.code}}</div>
    </div>

    <div class="ingredient-item misc" v-if="type === 'misc'">
      <div class="column name">
        <span>{{item.name}}</span>
      </div>
      <div class="column type" :title="item.type">{{item.type}}</div>
    </div>

    <div class="ingredient-item style" v-if="type === 'style'">
      <div class="column name">
        <span>{{item.name}}</span>
      </div>
    </div>
  </li>

</template>

<script>
    export default {
        name: "IngredientItem",
        props: {
            item: Object,
            selected: Number,
            itemIndex: Object,
            type: String
        },
        components: {
        },
        data() {
            return {
            };
        },
        methods: {
            onItemSelected() {
                this.$emit('item-selected', this.item)
            }
        },

        beforeMount() {

        },
        mounted () {

        }

    };
</script>

<style scoped lang="scss">
  @import "../../../src/assets/scss/variablesx";

  li {
    max-width: 100%;
  }

  .ingredient-item {
    display: flex;
    justify-content: space-evenly;

    .column {
      padding: 0 5px;

      &.name {
        span {
          display: block;
          margin-top: -5px;
          margin-bottom: 5px;
        }

        span + .sub-column {
          font-size: .7em;
          position: absolute;

          margin-top: -7px;
          color: $gray-700;
        }
      }
    }

    .selected & .column.name .sub-column { color: white; }

    &.fermentable .column.name      { flex-basis: 50%; }
    &.fermentable .column.type      { flex-basis: 40%; }
    &.fermentable .column.color     { flex-basis: 10%; }

    &.hop .column.name  { flex-basis: 50%; }
    &.hop .column.alpha { flex-basis: 20%; }
    &.hop .column.type  { flex-basis: 30%; }

    &.yeast .column.name { flex-basis: 50%; }
    &.yeast .column.type { flex-basis: 35%; }
    &.yeast .column.code { flex-basis: 15%; }

    &.misc .column.name  { flex-basis: 70%; }
    &.misc .column.type  { flex-basis: 30%; }

    &.style .column.name  { flex-basis: 100%; }
  }
</style>
